<template>
  <solution-sheet-sub-item :title="$t('Fibra superior')">
    <p v-if="isBracedByPanel">
      {{ $t("Fibra superior contraventada pelo painel/chapa") }}
    </p>

    <p v-else-if="isWithoutRestraints">{{ $t("Nenhum vão com travamento") }}</p>

    <template v-else>
      <p>{{ $t("Travamentos laterais") }}:</p>

      <template v-for="(val, i) in upperFibreValue">
        <p v-if="val !== 0" :key="i">V{{ i + 1 }}: {{ val }}</p>
      </template>
    </template>
  </solution-sheet-sub-item>
</template>

<script>
import { withoutDuplicates } from "@/utils";
import { SolutionSheetSubItem } from "@/components";

export default {
  components: {
    SolutionSheetSubItem,
  },

  props: {
    upperFibreValue: {
      type: Array,
      required: true,
    },
  },

  computed: {
    isBracedByPanel() {
      return this.upperFibreValue[0] === -1;
    },

    isWithoutRestraints() {
      return (
        withoutDuplicates(this.upperFibreValue).length === 1 &&
        this.upperFibreValue[0] === 0
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
